/* import __COLOCATED_TEMPLATE__ from './activity-row.hbs'; */
var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed, action } from '@ember/object';
import Component from '@ember/component';
import { inject as service } from '@ember/service';
const DEFAULT_BACKGROUND_COLOR = '#323A42';
function whiteMask() {
  return 'filter: brightness(0) invert(1);';
}
let ActivityRow = (_dec = computed('activity.merchantImage.{backgroundColorCode,isPrerendered}', 'screen.isMobile'), _class = class ActivityRow extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "screen", _descriptor, this);
    // row action can be any generic function that happens on row click
    // eslint-disable-next-line @typescript-eslint/ban-types
    _defineProperty(this, "rowAction", void 0);
    _defineProperty(this, "activity", void 0);
  }
  get activityIconStyles() {
    const backgroundColor = this.activity.merchantImage.backgroundColorCode || DEFAULT_BACKGROUND_COLOR;
    if (this.activity.merchantImage.isPrerendered) {
      return {
        backgroundColor: `background-color: ${backgroundColor};`,
        border: 'border-radius: 4px;',
        size: this.screen.isMobile ? 'width: 32px; height: 32px; padding: 0px;' : 'width: 24px; height: 24px; padding: 0px;'
      };
    } else {
      return {
        backgroundColor: `background-color: ${backgroundColor};`,
        filter: whiteMask()
      };
    }
  }
  doRowAction() {
    if (this.rowAction) {
      this.rowAction();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "screen", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "activityIconStyles", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "activityIconStyles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "doRowAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "doRowAction"), _class.prototype), _class);
export { ActivityRow as default };